/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.main' ).length ) {
        $( '#footer p' ).css( 'display', 'none' );
      }
      if ( $( '.ll-woocommerce' ).val !== undefined && $( '.ll-woocommerce' ).length ) {
        $( window ).on( 'load resize', function( event ) {
          const $navbar = $( '.navbar' );
          const $body = $( '.wrap' );
          $body.css( 'padding-top', $navbar.outerHeight( ) );
        } );
      }

      $( '.nav__menu-button' ).on( 'toggleAfter', ( event ) => {
        // $( '.primary-nav' ).slideToggle();
        $( 'body' ).toggleClass( 'overflow-hidden' );
      } );

      $( '.sub-menu-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).data( 'toggle-target' ) ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      $( 'a.btn--schedule, .btn--schedule a' ).magnificPopup( {
        type: 'inline',
        preloader: false,
        // focus: '#username',
        items: {
          src: '#schedule-popup',
          type: 'inline',
        },
      } );
    },
    finalize: function() {
      // console.log( ScrollTrigger.getAll() );
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
